import React from 'react';
import styled from '@emotion/styled';
import { useMenuContext } from 'context/MenuContext';
import { useScrollContext } from 'context/ScrollContext';
import useNoScroll from 'hooks/useNoScroll';

const ButtonWrapper = styled.button`
  cursor: pointer;
  /* 44px hit area (#245); the padding leaves a 1.8rem box for the bars. */
  min-height: 4.4rem;
  min-width: 4.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 1.3rem;
  background: none;
  border: none;
  outline: none;
  z-index: ${({ theme }) => theme.zIndices.mobileNav};

  ${({ theme }) => theme.mediaQueries.md} {
    display: none;
  }
`;

const MenuElement = styled.div`
  background-color: ${({ theme }) => theme.colors.red};
  height: 0.2rem;
  width: 100%;
  transform-origin: center;
  transition:
    background-color 0.3s ease-in-out,
    transform 0.3s ease-in-out;
`;

const MenuElementTop = styled(MenuElement)`
  transform: ${({ isOpen }) =>
    isOpen ? 'translateY(0.8rem) rotate(45deg)' : 'none'};
`;

const MenuElementBottom = styled(MenuElement)`
  transform: ${({ isOpen }) =>
    isOpen ? 'translateY(-0.8rem) rotate(-45deg)' : 'none'};
`;

const MenuButtonMobile = () => {
  const { isScrolled } = useScrollContext();
  const { menuOpen, toggleMenu } = useMenuContext();
  useNoScroll(menuOpen);

  return (
    <ButtonWrapper
      onClick={toggleMenu}
      aria-expanded={menuOpen}
      aria-label={menuOpen ? 'Close menu' : 'Open menu'}
    >
      <MenuElementTop
        isOpen={menuOpen}
        aria-hidden="true"
        isScrolled={isScrolled}
      />
      <MenuElementBottom
        isOpen={menuOpen}
        aria-hidden="true"
        isScrolled={isScrolled}
      />
    </ButtonWrapper>
  );
};

export default MenuButtonMobile;
